import { useEffect, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { isMuted, onMuteChange, setMuted } from "@/lib/audio";
import { useLang } from "@/lib/i18n";

export const MuteToggle = ({ className = "", iconClass = "w-5 h-5" }) => {
  const [m, setM] = useState(isMuted());
  useEffect(() => onMuteChange(setM), []);
  return (
    <button data-testid="audio-mute-toggle-button" aria-label="Toggle sound" onClick={() => setMuted(!m)} className={className}>
      {m ? <VolumeX className={iconClass} /> : <Volume2 className={iconClass} />}
    </button>
  );
};

export const LangToggle = ({ className = "" }) => {
  const { lang, setLang } = useLang();
  return (
    <div className={`inline-flex rounded-full border border-border bg-secondary/60 p-0.5 ${className}`}>
      {["en", "fi"].map((l) => (
        <button
          key={l}
          data-testid={`language-toggle-${l}-button`}
          onClick={() => setLang(l)}
          className={`px-3 py-1 text-xs font-bold rounded-full transition-colors ${lang === l ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground"}`}
        >
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
};
